import React, { useEffect } from "react";
import { axios_instance } from "../../../../api/axios_instance";

const PaymentTrancheFormButtons = ({
  stepDetails,
  caseDetails,
  saveAsDraft,
  lastCancellationDataArr,
  isReleaseBtnDis,
  paymentDetails,
  checkSuperMaker,
  disableAuthBtn,
  disableApproveBtn,
  btnDisplayMakerLead,
  state,
  setState,
  addTrancheFunc,
  makerSubmissionFunc,
  partPaymentSubmissionFunc,
  superMakerSubmissionFunc,
  checkerValidateFunc,
  otherSubmissionFunc,
  lastFormState,
  openApprovePaymentModal,
  openCancelPaymentModal,
  user,
}) => {
  let {
    btnDisplayMaker,
    btnDisplayHOD,
    btnDisplayPaylead,
    addTranche,
    firstBtnText,
    secondBtnTxt,
    thirdBtnText,
    btnSubmit,
    btnSubmitType,
    btnDisplayMakerPart,
    stageDirectRelease,
    substageDirectRelease,
    stageSubmitVal,
    substageSubmitVal,
    stageDraftVal,
    substageDraftVal,
    dropdownCancellationButton,
  } = stepDetails;

  const dtsPaymentMax = caseDetails.dts_pay_count
    ? caseDetails.dts_pay_count
    : 1;

  useEffect(() => {
    const fetchTrancheOptions = async () => {
      try {
        const res = await axios_instance({
          url: "/dts/getAddTrancheDropdownData",
          method: "POST",
          data: {
            dis_id: caseDetails?.id,
            finance_lead_id: caseDetails?.finance_lead_id,
          },
        });

        if (Array.isArray(res.data)) {
          setState((prev) => ({
            ...prev,
            trancheOptions: res.data,
          }));
        }
      } catch (error) {
        console.error("Error fetching tranche options:", error);
      }
    };

    fetchTrancheOptions();
  }, [caseDetails?.id]);

  return (
    <>
      {addTranche && state.payeeTypeList.length ? (
        <>
          {!state.hideNextTrancheDiv ? (
            <div
              className="clearfix pull-right form-group addtranchedrop"
              id="nextTrancheDiv"
            >
              {dropdownCancellationButton ? (
                <button
                  className="btn btn-tranche pad-L20 pad-R20"
                  onClick={addTrancheFunc}
                >
                  Add Tranche
                </button>
              ) : (
                <select
                  className="form-control"
                  value={state.selectedTranche || ""}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    state.selectedTranche = selectedValue;
                    if (selectedValue) {
                      addTrancheFunc();
                    }
                  }}
                >
                  <option value="">Select Tranche</option>
                  {state.trancheOptions?.length > 0 ? (
                    state.trancheOptions.map((t) => (
                      <option
                        key={t.value}
                        value={t.value}
                        disabled={t.disabled}
                        className={t.disabled ? "tranche-disabled" : ""}
                      >
                        {t.label}
                      </option>
                    ))
                  ) : (
                    <option disabled>No tranches available</option>
                  )}
                </select>
              )}
            </div>
          ) : (
            ""
          )}

          <div className="pull-right mrg-R10">
            {saveAsDraft ? (
              <button
                className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5"
                id="payBtn"
                style={{ display: "none" }}
                onClick={(e) => {
                  checkerValidateFunc(
                    lastFormState.addedTranche
                      ? dtsPaymentMax
                      : dtsPaymentMax - 1
                  );
                  e.stopPropagation();
                }}
              >
                {firstBtnText}
              </button>
            ) : (
              ""
            )}
            {state.showPayDraftBtn ? (
              <button
                className="btn rc-btn_rset pad-L20 pad-R20"
                id="payDraftBtn"
                disabled={state.PayDraftBtnDisabled ? true : false}
                onClick={(e) => {
                  e.preventDefault();
                  partPaymentSubmissionFunc(
                    lastFormState.addedTranche
                      ? paymentDetails.length
                      : paymentDetails.length - 1,
                    stepDetails.btnDraftType,
                    1,
                    2
                  );
                  e.stopPropagation();
                }}
              >
                {secondBtnTxt}
              </button>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      {(() => {
        const subStageCheck = ["1", "2", "3", "4", "12", "14"].includes(
          caseDetails.sub_stage
        );
        let smAuthBtnTxt = "",
          smAuthClass = "",
          smAuthSubStage = "";
        if (saveAsDraft) {
          // btnDraftType = "submit";

          smAuthSubStage = "8";
          smAuthBtnTxt = "Authorize";
          smAuthClass = "green-status";
          if (Object.keys(lastCancellationDataArr).length > 1) {
            smAuthSubStage = "10";
            smAuthBtnTxt = "Cancel Payment";
            smAuthClass = " red-status ";
          }
        }

        const btnDisplayRelease =
          paymentDetails.length &&
          paymentDetails[paymentDetails.length - 1].payable_ac_number ===
            "Direct Payment"
            ? true
            : isReleaseBtnDis;

        const isAssignedToSelf = caseDetails.pay_head_id === user.id;

        const btnAuthDisplay =
          Object.keys(lastCancellationDataArr).length <= 1 ||
          btnDisplayRelease === false
            ? true
            : false;

        if (checkSuperMaker && !addTranche) {
          return (
            <>
              <div className="pull-right mrg-R10">
                <div className="form-group">
                  {subStageCheck && saveAsDraft ? (
                    <>
                      <button
                        className={`btn rc-btn_primary pad-L20 pad-R20 mrg-R5 ${smAuthClass} authTrancheBtn`}
                        disabled={
                          typeof state.disabled_authTrancheBtn === "object"
                            ? disableAuthBtn
                            : state.disabled_authTrancheBtn
                        }
                        onClick={(e) => {
                          superMakerSubmissionFunc(
                            "submit",
                            smAuthSubStage,
                            "dtStage2"
                          );
                          e.stopPropagation();
                        }}
                      >
                        {smAuthBtnTxt}
                      </button>
                      <button
                        className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5 authTrancheBtn"
                        disabled={
                          typeof state.disabled_authTrancheBtn === "object"
                            ? disableAuthBtn
                            : state.disabled_authTrancheBtn
                        }
                        onClick={(e) => {
                          superMakerSubmissionFunc("submit", 7, "dtStage2");
                          e.stopPropagation();
                        }}
                      >
                        Send for Authorization
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                  {subStageCheck && btnDisplayMakerPart ? (
                    <button
                      className="btn rc-btn_rset pad-L20 pad-R20"
                      onClick={(e) => {
                        partPaymentSubmissionFunc(
                          lastFormState.addedTranche
                            ? paymentDetails.length
                            : paymentDetails.length - 1,
                          "draft",
                          stageDraftVal,
                          substageDraftVal
                        );
                        e.stopPropagation();
                      }}
                    >
                      {secondBtnTxt}
                    </button>
                  ) : (
                    ""
                  )}
                  {subStageCheck && !btnDisplayMakerPart ? (
                    <button
                      className="btn rc-btn_rset pad-L20 pad-R20"
                      onClick={(e) => {
                        makerSubmissionFunc(dtsPaymentMax - 1, "draft");
                        e.stopPropagation();
                      }}
                    >
                      {secondBtnTxt}
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* <input
                type="hidden"
                id="sm_action"
                name="sm_action"
                value={state.sm_action}
                readOnly
              ></input> */}
            </>
          );
        } else {
          return (
            <>
              <div className="pull-right mrg-R10">
                <div className="form-group">
                  {btnDisplayMaker && (
                    <>
                      {btnSubmit && saveAsDraft ? (
                        <button
                          type="button"
                          className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5"
                          onClick={(e) => {
                            checkerValidateFunc(0);
                            e.stopPropagation();
                          }}
                        >
                          {firstBtnText}
                        </button>
                      ) : (
                        ""
                      )}
                      <button
                        type="button"
                        className="btn rc-btn_rset pad-L20 pad-R20"
                        onClick={(e) => {
                          makerSubmissionFunc(dtsPaymentMax - 1, "draft");
                          e.stopPropagation();
                        }}
                      >
                        {secondBtnTxt}
                      </button>
                    </>
                  )}
                  {btnDisplayMakerPart && (
                    <>
                      {saveAsDraft ? (
                        <button
                          type="button"
                          className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5"
                          onClick={(e) => {
                            checkerValidateFunc(
                              lastFormState.addedTranche
                                ? dtsPaymentMax
                                : dtsPaymentMax - 1
                            );
                            e.stopPropagation();
                          }}
                        >
                          {firstBtnText}
                        </button>
                      ) : (
                        ""
                      )}
                      <button
                        type="button"
                        className="btn rc-btn_rset pad-L20 pad-R20"
                        onClick={(e) => {
                          partPaymentSubmissionFunc(
                            lastFormState.addedTranche
                              ? paymentDetails.length
                              : paymentDetails.length - 1,
                            "draft",
                            stageDraftVal,
                            substageDraftVal
                          );
                          e.stopPropagation();
                        }}
                      >
                        {secondBtnTxt}
                      </button>
                    </>
                  )}
                  {btnDisplayPaylead ? (
                    <>
                      {console.log(
                        !btnDisplayRelease ||
                          !btnAuthDisplay ||
                          isAssignedToSelf
                      )}

                      {!btnDisplayRelease ||
                      !btnAuthDisplay ||
                      !isAssignedToSelf ? (
                        ""
                      ) : (
                        <button
                          type="button"
                          className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5 green-status approveTrancheBtn"
                          disabled={
                            disableApproveBtn &&
                            state.disabled_approveTrancheBtn
                          }
                          onClick={(e) => {
                            otherSubmissionFunc(
                              btnSubmitType,
                              stageDirectRelease,
                              substageDirectRelease,
                              "dtStage2"
                            );
                            e.stopPropagation();
                          }}
                        >
                          {thirdBtnText}
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5"
                        onClick={(e) => {
                          otherSubmissionFunc(
                            btnSubmitType,
                            stageSubmitVal,
                            substageSubmitVal,
                            "dtStage2"
                          );
                          e.stopPropagation();
                        }}
                      >
                        {firstBtnText}
                      </button>
                      <button
                        type="button"
                        className="btn rc-btn_rset pad-L20 pad-R20"
                        onClick={(e) => {
                          otherSubmissionFunc(
                            stepDetails.btnDraftType,
                            stageDraftVal,
                            substageDraftVal,
                            "dtStage2"
                          );
                          e.stopPropagation();
                        }}
                      >
                        {secondBtnTxt}
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                  {btnDisplayHOD ? (
                    <>
                      {!btnDisplayRelease || !btnAuthDisplay ? (
                        ""
                      ) : (
                        <button
                          type="button"
                          className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5 green-status approveTrancheBtn"
                          disabled={
                            disableApproveBtn &&
                            state.disabled_approveTrancheBtn
                          }
                          onClick={(e) => {
                            openApprovePaymentModal();
                            e.stopPropagation();
                          }}
                        >
                          {firstBtnText}
                        </button>
                      )}

                      <button
                        type="button"
                        className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5 approveTrancheBtn"
                        disabled={
                          disableApproveBtn && state.disabled_approveTrancheBtn
                        }
                        onClick={(e) => {
                          openCancelPaymentModal();
                          e.stopPropagation();
                        }}
                      >
                        {secondBtnTxt}
                      </button>
                      <button
                        type="button"
                        className="btn rc-btn_rset pad-L20 pad-R20"
                        onClick={(e) => {
                          otherSubmissionFunc(
                            stepDetails.btnDraftType,
                            stageDraftVal,
                            substageDraftVal,
                            "dtStage2"
                          );
                          e.stopPropagation();
                        }}
                      >
                        {thirdBtnText}
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                  {console.log({ isAssignedToSelf })}
                  {btnDisplayMakerLead ? (
                    <>
                      {!btnDisplayRelease ||
                      !btnAuthDisplay ||
                      isAssignedToSelf ? (
                        ""
                      ) : (
                        <button
                          type="button"
                          className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5 green-status approveTrancheBtn"
                          disabled={
                            disableApproveBtn &&
                            state.disabled_approveTrancheBtn
                          }
                          onClick={(e) => {
                            otherSubmissionFunc(
                              btnSubmitType,
                              stageDirectRelease,
                              substageDirectRelease,
                              "dtStage2"
                            );
                            e.stopPropagation();
                          }}
                        >
                          {thirdBtnText}
                        </button>
                      )}

                      <button
                        type="button"
                        className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5"
                        onClick={(e) => {
                          otherSubmissionFunc(
                            btnSubmitType,
                            stageSubmitVal,
                            substageSubmitVal,
                            "dtStage2"
                          );
                          e.stopPropagation();
                        }}
                      >
                        {firstBtnText}
                      </button>
                      <button
                        type="button"
                        className="btn rc-btn_rset pad-L20 pad-R20"
                        onClick={(e) => {
                          otherSubmissionFunc(
                            stepDetails.btnDraftType,
                            stageDraftVal,
                            substageDraftVal,
                            "dtStage2"
                          );
                          e.stopPropagation();
                        }}
                      >
                        {secondBtnTxt}
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                  {!btnDisplayMaker &&
                  !btnDisplayMakerPart &&
                  !btnDisplayPaylead &&
                  !btnDisplayHOD &&
                  !btnDisplayMakerLead ? (
                    <div className="clearfix dts-save-details"></div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </>
          );
        }
      })()}
    </>
  );
};

export default PaymentTrancheFormButtons;
